<template>
<div class="wrapper">
  <el-row>
    <el-card class="card">
      <span slot="header">数据统计</span>
      <el-row type="flex" justify="space-between">
        <count-to :number="stats.download.limit" :editable="true" @click.native="onSetDownloadLimit()" icon="download-limit" text="单日下载上限" color="#40c9c6" />
        <count-to :number="stats.number.download" icon="download" text="下载总量" color="#d87a80" />
        <count-to :number="stats.number.visit" icon="visit" text="访问数量" color="#b6a2de" />
        <count-to :number="stats.number.teacher" icon="teacher" text="教师数量" color="#36a3f7" />
      </el-row>
    </el-card>
  </el-row>
  <el-row>
    <el-card class="card">
      <span slot="header">教师管理</span>
      <el-table height="400px" :data="table.data" v-el-table-infinite-scroll="loadData" infinite-scroll-disabled="loadingDisabled">
        <el-table-column prop="userId" label="账号"></el-table-column>
        <el-table-column prop="userName" label="姓名"></el-table-column>
        <el-table-column prop="admin" label="管理员">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.admin" :active-value="1" :inactive-value="0" @change="onSwitchAdmin(scope.row)"></el-switch>
          </template>
        </el-table-column>
      </el-table>
      <el-alert v-if="table.loading"
            title="正在努力加载中..."
            type="success"
            center
            :closable="false"
            show-icon>
      </el-alert>
      <el-alert v-if="table.unload"
            title="没有更多啦！"
            type="warning"
            center
            show-icon>
      </el-alert>
    </el-card>
  </el-row>
  <el-row>
    <el-card class="card">
      <span slot="header">数据上传</span>
      <el-row class="item-margin">
        <el-select size="medium" placeholder="年份" filterable v-model="dataset.path.year">
          <el-option v-for="item in dataset.ops.years" :key="item" :value="item" :label="item"></el-option>
        </el-select>
        <el-select size="medium" placeholder="省" filterable v-model="dataset.path.provinceCode" @change="selectProvince">
          <el-option v-for="item in dataset.ops.provinces" :key="item.code" :value="item.code" :label="item.name"></el-option>
        </el-select>
        <el-divider direction="vertical"></el-divider>
        <el-select size="medium" placeholder="市" filterable v-model="dataset.path.cityCode" @change="selectCity">
          <el-option v-for="item in dataset.ops.cities" :key="item.code" :value="item.code" :label="item.name"></el-option>
        </el-select>
        <el-divider direction="vertical"></el-divider>
        <el-select size="medium" placeholder="部门" filterable allow-create v-model="dataset.path.department">
          <el-option v-for="item in dataset.ops.departments" :key="item.code" :value="item.code" :label="item.code"></el-option>
        </el-select>
        <el-divider direction="vertical"></el-divider>
        <el-select size="medium" placeholder="数据集" v-model="dataset.path.fileTitle" value-key="id" filterable allow-create remote :remote-method="loadDatasets" @change="selectDataset">
          <el-option v-for="item in dataset.ops.datasets" :key="item.id" :value="item" :label="item.fileTitle"></el-option>
        </el-select>
      </el-row>
      <upload class="item-margin" :path="getRelativePath()" v-model="dataset.files"></upload>
      <el-button class="item-margin" type="success" @click="importData()">导入</el-button>
    </el-card>
  </el-row>
  <el-dialog title="设置单日下载上限" width="30%" :visible.sync="stats.download.visible">
    <el-input type="number" v-model.number="stats.download.limit"></el-input>
    <span slot="footer" class="dialog-footer">
      <el-button @click="getDownloadLimit();stats.download.visible = false">取 消</el-button>
      <el-button type="primary" @click="putDownloadLimit()">确 定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
import MainBanner from '@/pages/homepage/components/Banner'
import HomeMain from '@/pages/homepage/components/Main'
import CountTo from '@/pages/common/CountTo'
import Upload from '@/pages/common/Upload'
import { getDownloadLimit, putDownloadLimit, getStatsDownload, getStatsVisit, getStatsTeacher, loadTeachers, setAdmin, getYears, getProvinces, getCities, importEntry } from '@/api/admin'
import { getDepartments, getEntries } from '@/api/search'
import { Message, MessageBox } from 'element-ui'

export default {
  name: 'Admin',
  components: {
    HomeMain,
    MainBanner,
    CountTo,
    Upload
  },
  data () {
    return {
      stats: {
        download: {
          limit: 0,
          visible: false
        },
        number: {
          download: 0,
          visit: 0,
          teacher: 0
        }
      },
      table: {
        data: [],
        next: 1,
        unload: false,
        loading: false
      },
      dataset: {
        files: [],
        path: {
          year: '',
          provinceCode: '',
          province: '',
          cityCode: '',
          city: '',
          department: '',
          fileTitle: ''
        },
        ops: {
          provinces: [],
          cities: [],
          departments: [],
          datasets: []
        },
        item: {}
      }
    }
  },
  mounted () {
    this.getDownloadLimit()
    this.getStatsDownload()
    this.getStatsVisit()
    this.getStatsTeacher()
    getYears().then(({data}) => {
      this.dataset.ops.years = data
    })
  },
  methods: {
    selectProvince (val) {
      this.dataset.path.province = this.dataset.ops.provinces.find(x => x.code === val).name
    },
    selectCity (val) {
      this.dataset.path.city = this.dataset.ops.cities.find(x => x.code === val).name
    },
    getRelativePath () {
      const path = this.dataset.path
      const item = this.dataset.item
      return `/${path.year}/${path.province}/${path.city}/${path.department}/${item.fileTitle || item}`
    },
    importData () {
      const params = {
        ...this.dataset.item,
        ...this.dataset.path,
        fileTitle: this.dataset.item.fileTitle || this.dataset.item,
        dataSetFiles: JSON.stringify(this.dataset.files)
      }
      MessageBox.confirm('确认是否提交数据更新',
        '数据更新',
        {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        importEntry(params).then(() => {
          Message.success('提交成功')
          this.dataset.path.provinceCode = ''
        })
      })
    },
    getDatasets () {
      const path = this.dataset.path
      if (path.provinceCode !== '' && path.cityCode !== '' && path.department !== '') {
        const params = {
          ...path,
          page: 1,
          pageSize: 100
        }
        getEntries(params).then(({data}) => {
          this.dataset.ops.datasets = data.records
        })
      } else {
        this.dataset.ops.datasets = []
      }
    },
    selectDataset (item) {
      this.dataset.item = item
      if (item.dataSetFiles) {
        this.dataset.files = JSON.parse(item.dataSetFiles)
      } else {
        this.dataset.files = []
      }
    },
    loadDatasets (query) {
      if (query !== '') {
        const params = {
          ...this.dataset.path,
          page: 1,
          pageSize: 100,
          fileTitle: query
        }
        getEntries(params).then(({data}) => {
          this.dataset.ops.datasets = data.records
        })
      } else {
        this.getDatasets()
      }
    },
    loadData () {
      const params = {page: this.table.next++, pageSize: 10}
      this.table.loading = true
      loadTeachers(params).then(({data}) => {
        const records = data.data
        this.table.data = this.table.data.concat(records)
        this.table.unload = !data.hasNext
        this.table.loading = false
      })
    },
    reloadData () {
      this.table.data = []
      this.table.next = 1
      this.unload = false
      this.loadData()
    },
    onSwitchAdmin (user) {
      MessageBox.confirm('确定是否设置为管理员',
        '管理员设置',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        setAdmin(user).then(({data}) => {
          Message.success('修改成功')
          this.reloadData()
        })
      })
    },
    getDownloadLimit () {
      getDownloadLimit().then(({data}) => {
        this.stats.download.limit = data
      })
    },
    getStatsDownload () {
      getStatsDownload().then(({data}) => {
        this.stats.number.download = data
      })
    },
    getStatsVisit () {
      getStatsVisit().then(({data}) => {
        this.stats.number.visit = data
      })
    },
    getStatsTeacher () {
      getStatsTeacher().then(({data}) => {
        this.stats.number.teacher = data
      })
    },
    onSetDownloadLimit () {
      this.stats.download.visible = true
    },
    putDownloadLimit () {
      MessageBox.confirm(
        '确定修改单日下载上限吗',
        '更新单日下载上限',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        this.stats.download.visible = false
        putDownloadLimit({limit: this.stats.download.limit}).then(({data}) => {
          Message({
            message: '修改成功',
            type: 'success',
            duration: 3 * 1000
          })
        })
      })
    }
  },
  computed: {
    loadingDisabled () {
      return this.table.loading || this.table.unload
    }
  },
  watch: {
    'dataset.path.year' (val) {
      this.dataset.path.provinceCode = ''
      getProvinces().then(({data}) => {
        this.dataset.ops.provinces = data
      })
    },
    'dataset.path.provinceCode' (val) {
      this.dataset.path.cityCode = ''
      if (val === '') {
        this.dataset.ops.cities = []
        return
      }
      getCities(this.dataset.path).then(({data}) => {
        this.dataset.ops.cities = data
      })
    },
    'dataset.path.cityCode' (val) {
      this.dataset.path.department = ''
      if (val === '') {
        this.dataset.ops.departments = []
        return
      }
      getDepartments(this.dataset.path).then(({data}) => {
        this.dataset.ops.departments = data
      })
    },
    'dataset.path.department' (val) {
      this.dataset.path.fileTitle = ''
      this.dataset.item = {}
      this.dataset.files = []
      this.getDatasets()
    }
  }
}
</script>

<style scope>
.wrapper{
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 50px;
    margin-right: 50px;
}
.card{
  margin: 20px;
  border-radius: 5px;
}
.cycle-border {
  border-radius: 30px
}
.item-margin {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/AdminPage.vue